import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NotificationsSidebarService {
  private readonly isOpened$ = new BehaviorSubject(false);

  public readonly isVisible$ = this.isOpened$.asObservable();

  public toggle(value?: boolean): void {
    this.isOpened$.next(value !== undefined ? value : !this.isOpened$.value);
  }
}
